import ToggleButton from 'vue-js-toggle-button/src/Button'

let toggleButtonMixin = {
  components: { ToggleButton }
}

export default toggleButtonMixin
